/**
 * Rejection for a request whose 401, 403 or 404 response already sent the
 * visitor to the matching error page. Callers' error handlers skip the toast
 * and the error log for it, since the error page already shows it.
 */
export default class HttpRedirectError extends Error {
  status: number;

  constructor(status: number, message?: string) {
    super(message);
    this.name = 'HttpRedirectError';
    this.status = status;
  }
}

export const isHttpRedirectError = (err: unknown): err is HttpRedirectError =>
  err instanceof HttpRedirectError;
